import axios from "axios";
import config from "@/config";
import VueJwtDecode from "vue-jwt-decode";

export default {
  getAccessToken(user, success, error) {
    var url = config.API_ENDPOINT + "token/access";
    axios
      //.get(config.config.SLAPManager + "/SlapBuild/4")
      .post(url, user)
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getAccessTokenByRefreshToken(refershObject, success, error) {
    var url = config.API_ENDPOINT + "/token/refresh";
    const FormData = require("form-data");
    const formData = new FormData();
    formData.append("grant_type", "refresh_token");
    formData.append("refresh_token", refershObject.refresh_token);
    formData.append("username", refershObject.username);
    axios
      //.get(config.config.SLAPManager + "/SlapBuild/4")
      .post(url, formData)
      .then(response => {
        //console.log("refreshToken", response.data);
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  decodeJWTToken(token) {
    return VueJwtDecode.decode(token);
  },
  accessTokenValidation(token, expiryDate) {
    if (token) {
      var clientUTCDate = new Date().toUTCString();
      var expiryUTCDate = new Date(expiryDate).toUTCString();
      if (new Date(clientUTCDate) > new Date(expiryUTCDate)) {
        console.log("Token Expired");
        return false;
      }
      return true;
    }
    return false;
  }
};
